import { z } from "zod";

export const perfSchema = z.object({
    shareclass: z.number(),
    part_id: z.number(),
    version: z.string(),
});

export type PerfType = z.infer<typeof perfSchema>;

export const dataPartSchema = z.object({
    key: z.string().optional(),
    title: z.string().optional(),
    tabs: z.boolean().optional(),
});

export const messageDataSchema = z.object({
    data: z.string().or(z.record(z.string())),
});

export const messageSchema = z.object({
    warning: z.object({ part: messageDataSchema }).optional(),
    info: z.object({ part: z.array(messageDataSchema.optional()) }).optional(),
});

export type InfoParts = z.infer<typeof messageSchema>;
